import { FC } from 'react';
import {
  Box,
  Button,
  Heading,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';

type Props = {
  isOpen: boolean;
  title: string;
  handleClose: () => void;
  handleClickGoInput: () => void;
  handleClickDelete: () => void;
};

export const DeleteModalView: FC<Props> = ({
  isOpen,
  title,
  handleClose,
  handleClickGoInput,
  handleClickDelete,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={handleClose}
    size="lg"
    blockScrollOnMount
    closeOnOverlayClick={false}
    closeOnEsc={false}
  >
    <ModalOverlay />
    <ModalContent>
      <ModalHeader p="40px 40px 0 40px">お知らせ削除</ModalHeader>
      <ModalCloseButton />
      <ModalBody overflowY="auto" p="0 40px 0 40px">
        <Box mt="40px">
          <Heading as="h5" size="sm">
            タイトル
          </Heading>
          <Text fontSize="md">{title}</Text>
        </Box>
      </ModalBody>
      <ModalFooter justifyContent="center" mt="20px" mb="20px">
        <VStack>
          <Text fontSize="lg" textAlign="center">
            上記の内容のお知らせを削除しますか？
          </Text>
          <Box h="20px" />
          <HStack>
            <Button
              colorScheme="gray"
              variant="outline"
              mr={3}
              onClick={handleClickGoInput}
            >
              入力画面へ戻る
            </Button>

            <Button
              width="140px"
              colorScheme="red"
              mr={3}
              onClick={handleClickDelete}
            >
              削除
            </Button>
          </HStack>
        </VStack>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
